export const BUSINESS = {
  name: "Earlwood Automatic Car Wash",
  address: "200 Homer St, Earlwood NSW 2206",
  site: "At Speedway Earlwood",
  phone: "02 9558 5155",
  phoneHref: "tel:+61295585155",
  stationHours: "Petrol station open 24 hours, 7 days",
};

export const IMAGES = {
  vacuumMat: "https://customer-assets-jai6qajn.emergentagent.net/job_plate-wash-hub/artifacts/4f6974abd6dd7709_Clean%20Car%20Wash%20Vacuum%20Bays.png",
  speedway: "https://customer-assets-jai6qajn.emergentagent.net/job_plate-wash-hub/artifacts/f00836d0593454a0_Clean%20SPEEDWAY%20Station%20Forecourt.png",
  selfServe: "https://customer-assets-jai6qajn.emergentagent.net/job_plate-wash-hub/artifacts/6eaf1039f6e8f477_Earlwood%20Self-Service%20Car%20Wash%20at%20Dusk.png",
  dogWash: "https://customer-assets-jai6qajn.emergentagent.net/job_plate-wash-hub/artifacts/549ae4560eba02c5_Vibrant%20K9000%20Self-Service%20Dog%20Wash.png",
  autoWash: "https://customer-assets-jai6qajn.emergentagent.net/job_plate-wash-hub/artifacts/70b1c836d1af687d_Modern%20Car%20Wash%20Storefront%20Facade.png",
};

export const SELF_SERVE = {
  hours: "6AM – 10PM",
  from: "$6",
  per: "5 min",
  features: ["High pressure wash", "Foam brush", "Rinse & wax"],
};

export const VACUUM = { name: "Power Vacuum", price: "$2", sub: "5 min", features: ["Separate vacuum station", "Pay as you go"] };

export const MAT_CLEANER = { name: "Mat Cleaner", price: "$1", sub: "1.5 min", features: ["Clean all your car mats", "Pay as you go"] };

export const MAT_CLEANER_STEPS = ["Insert $1", "Press start", "Insert car mat", "Keep fingers & hands clear", "Take mat from bottom tray"];

export const AUTO_WASH_HOURS = "Open 24 hours, 7 days";

export const FUEL_DISCOUNT = "Fill up $5 or more of fuel and save $5 on Express, Deluxe, VIP or Super Polish";

export const AUTO_WASH = [
  { name: "Express Wash", price: "$15", fuelPrice: "$10", features: ["Wash", "Wheel wash", "Fast dry"] },
  { name: "Deluxe Wash", price: "$19", fuelPrice: "$14", features: ["Wash", "Wheel wash", "Pre soak foam", "Fast drying"] },
  { name: "VIP Wash", price: "$22", fuelPrice: "$17", features: ["Wash", "Wheel wash", "Pre soak foam", "Ceramic wax spray", "Slow dry"] },
  { name: "Super Polish", price: "$24", fuelPrice: "$19", badge: "Best Shine", featured: true, features: ["Wash", "Wheel wash", "Pre soak foam", "Ceramic wax polish", "Slow dry"] },
];

export const QUICK_WASH = { name: "Quick Wash", price: "$6", sub: "With fuel", features: ["Wash only", "No dry"] };

export const AUTO_WASH_STEPS = ["Type code in rear", "Proceed to red light", "Fold mirrors in", "Remove loose parts"];

export const DOG_WASH_FEATURES = ["Shampoo", "Conditioner", "Flea rinse", "Blow dry"];

export const DOG_WASH_HOURS = "Open 24 hours, 7 days";

export const DOG_WASH = { name: "Dog Wash", price: "$10", sub: "10 min", features: ["Shampoo", "Conditioner", "Flea rinse", "Blow dry", "Top up anytime", "Open 24/7"] };
